
<div [style.height.px]="24">
  @if (!exporting) {
    <div data-html2canvas-ignore class="btn-group {{theme$ | async}} ">
      @if (options) {
        <lib-select
          [options]="options"
          [label]="'BUTTONS.EXPORT' |translate"
          [border]="'custom-border'"
          [classes]="'font-size-normal-small text-primary h-100 text-left'"
          [withIcon]="true"
          [notBold]="true"
          [fullWidth]="true"
          [itemClasses]="'font-size-normal-small'"
          [doNotTranslate]="true"
          [container]="''"
          [size]="size"
          [disabled]="disabled"
          [ngClass]="{'disabled-pointer': disabled , 'cursor-pointer': !disabled}"
          (selectedChanged)="onDropdownSelected($event)">
          <ng-container icon>
            <i class="far fa-download font-icons pointer mr-2"></i>
            <span class="pointer" > {{'BUTTONS.EXPORT' | translate}} </span>
          </ng-container>
        </lib-select>
      }
    </div>
  }

  @if (exporting) {
    <app-spinner  data-html2canvas-ignore  ></app-spinner>
  }
</div>